export default __webpack_public_path__ + "7e437b76977dc41d00a1c942543a5582.svg";